export default __webpack_public_path__ + "static/media/sample-profile.dddd22da.png";